import { render, staticRenderFns } from "./ValetRegistration.vue?vue&type=template&id=f70b9662&scoped=true"
import script from "./ValetRegistration.vue?vue&type=script&lang=tsx"
export * from "./ValetRegistration.vue?vue&type=script&lang=tsx"
import style0 from "./ValetRegistration.vue?vue&type=style&index=0&id=f70b9662&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70b9662",
  null
  
)

export default component.exports